export default __webpack_public_path__ + "static/media/bacquevillemini.dc52c66b.jpg";